import parse from "html-react-parser"
import List from "../Page/List"

export default function StartingPoint( props ) {
	const c = props.cruise

	if ( !c.location_start_address || !c.location_start_address ) return null

	return <>
		{ parse( c.location_start_address ) || '' }
	</>
}
